import React from "react";
import Loading from "../../components/Loading";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import ChipInput from "material-ui-chip-input";
import { reg } from "../../constants/emailRegEx";
import {
  sendVideoToEmail,
  sendMultipleEmails,
} from "../../Redux/Actions/videos";
import { EmailVideo, MultiEmail } from "../../Redux/Types/videos";
import "./style.css";

interface IProps {
  sendMultipleEmail: (emailVideoObj: any) => void;
  sendVideoToEmail: (email: any) => void;
  progressEmail: boolean;
  loading: boolean;
  match: any;
  video: any;
}

class Share extends React.Component<IProps> {
  state = { recieverEmail: "", emails: [] as string[], provider: "sendgrid" as "sendgrid" | "gmail" };

  emailHandler = (event: any) => this.setState({ recieverEmail: event.target.value });

  handleChipAdd = (email: any) => {
    if (!reg.test(email)) { toast.error("Not a valid email"); return; }
    this.setState({ emails: [...this.state.emails, email] });
  };
  handleDeleteChip = (delEmail: any) => {
    this.setState({ emails: this.state.emails.filter((e) => e !== delEmail) });
  };

  submitEmail = () => {
    const { id } = this.props.match.params;
    if (!id) return toast.warn("No video to share");
    if (!this.state.recieverEmail) return toast.warn("Add an email");
    if (!reg.test(this.state.recieverEmail)) return toast.warn("Invalid email");
    this.props.sendVideoToEmail({ videoId: id, recieverEmail: this.state.recieverEmail, provider: this.state.provider } as any);
    this.setState({ recieverEmail: "" });
  };

  sendMultipleEmail = () => {
    const { id } = this.props.match.params;
    if (this.state.emails.length === 0) { toast.error("No email provided"); return; }
    if (!id) { toast.error("No video saved"); return; }
    if (this.state.emails.length < 2) { toast.error("Add at least two emails"); return; }
    this.props.sendMultipleEmail({ recieverEmail: this.state.emails.join(), videoId: id, provider: this.state.provider } as any);
    this.setState({ emails: [] });
  };

  render() {
    const { loading, progressEmail } = this.props;
    return (
      <div>
        {(loading || progressEmail) && <div className="progressEditing"><Loading /></div>}

        <div style={{ marginBottom: 16 }}>
          <label className="vtShareLabel">Send via</label>
          <div className="vtShareRow" role="radiogroup" aria-label="Email provider">
            <label style={{ marginRight: 16 }}>
              <input
                type="radio"
                name="email-provider"
                checked={this.state.provider === "sendgrid"}
                onChange={() => this.setState({ provider: "sendgrid" })}
              />{" "}Viideon (SendGrid)
            </label>
            <label>
              <input
                type="radio"
                name="email-provider"
                checked={this.state.provider === "gmail"}
                onChange={() => this.setState({ provider: "gmail" })}
              />{" "}My Gmail
            </label>
          </div>
          {this.state.provider === "gmail" && (
            <p style={{ fontSize: 12, opacity: 0.8 }}>Requires your Google account connected in Configuration. Falls back with a clear error if not connected.</p>
          )}
        </div>

        <div style={{ marginBottom: 28 }}>
          <label className="vtShareLabel">Send to Email</label>
          <div className="vtShareRow">
            <input
              type="email"
              className="vtShareInput"
              placeholder="Enter email address"
              value={this.state.recieverEmail}
              onChange={this.emailHandler}
            />
            <button className="vtShareSendBtn" onClick={this.submitEmail}>Send</button>
          </div>
        </div>

        <div className="vtShareDivider" />

        <div>
          <label className="vtShareLabel">Broadcast to Multiple</label>
          <ChipInput
            value={this.state.emails}
            placeholder="Type email and press enter"
            fullWidth
            onAdd={(chips) => this.handleChipAdd(chips)}
            onDelete={(chip) => this.handleDeleteChip(chip)}
            className="vtShareChipInput"
          />
          <button className="vtShareBroadcastBtn" onClick={this.sendMultipleEmail}>
            Broadcast
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  progressEmail: state.video.progressEmail,
  loading: state.video.loading,
  isVideoUpdating: state.video.isVideoUpdating,
  video: state.video.singleVideo,
});
const mapDispatchToProps = (dispatch: any) => ({
  sendVideoToEmail: (video: EmailVideo) => dispatch(sendVideoToEmail(video)),
  sendMultipleEmail: (emailVideoObj: MultiEmail) => dispatch(sendMultipleEmails(emailVideoObj)),
});
export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(Share));
